// Unpublished Work © 2022-2024 Deere & Company.

export const MAINTENANCE = 'maintenance';
export const HISTORY = 'history';
export const JOBS = 'jobs';
export const PARTS = 'parts';
export const EXPENSES = 'expenses';
